<div class="form-date">
  @if (label()) {
    <label [for]="id()" class="form-date__label">
      {{ label() | translate }}
      @if (control().hasValidator('required')) {
        <span class="form-date__required" aria-label="required">*</span>
      }
    </label>
  }
  
  <input
    #dateInput
    [id]="id()"
    type="date"
    [formControl]="control()"
    [readonly]="readonly()"
    [attr.aria-invalid]="shouldShowError"
    [attr.aria-describedby]="shouldShowError ? id() + '-error' : null"
    class="form-date__field"
    [class.form-date__field--error]="shouldShowError"
    (keydown)="onKeydownPicker($event, dateInput)"
  />
  
  @if (shouldShowError) {
    <div 
      [id]="id() + '-error'" 
      role="alert"
      aria-live="polite"
    >
      <app-validation-message [control]="control()" />
    </div>
  }
</div>
